The organization that has the advertisement branding.
